module.exports = __webpack_public_path__ + "static/aiNlp-8fb5c32c922cad23b9e2aca3b6e30e6f.jpg";